import { ETimeAggregationTypes, TTimeAggregationTypes } from '@enums/common';

export const COUNT_OF_COLORS = 16;
export const FONT_SIZE_LEGEND = 14;
export const LABEL_SIZE_LEGEND = 10;
export const ANNOTATIONS_BORDER_WIDTH = 1;
export const LEGEND_POSITION = 'bottom';
export const LEGEND_ALIGN = 'start';
export const MAX_COUNT_OF_COMPARE_CHARTS = 10;
export const MIN_COUNT_OF_COMPARE_CHARTS = 2;
export const COUNT_OF_CORRELATE_CHARTS = 2;
export const MIN_POINTS_IN_CHART = 3;
export const HALF_YEAR_DATE_INTERVAL = 179;
export const YEAR_DATE_INTERVAL = 364;
export const MIN_BAR_LENGTH = 2;
export const RADIX = 10;
export const SUGGESTED_MIN = 0;
export const SUGGESTED_MAX = 100;
export const LOGARITHMIC_MINIMUM_VALUE = 0.1;

export const listOfTimeAggregationTypes: Array<TTimeAggregationTypes> = [
	ETimeAggregationTypes.seconds,
	ETimeAggregationTypes.minutes,
	ETimeAggregationTypes.hours,
	ETimeAggregationTypes.days,
	ETimeAggregationTypes.months,
];

export const labelColorStyle = {
	borderWidth: 0.2,
	borderDash: [],
	borderRadius: 5,
	width: 10,
	height: 10,
};

export const TOOLTIP_SHARED_PRESET_INFO =
	'A shared preset is available for all users within the organisation who have the appropriate access, and can be edited by any of them';

export const TOOLTIP_SHARED_PRESET_IRREVERSIBLE =
	'A shared preset cannot be converted back to a personal one. To keep a personal version, please save it as a new preset.';

export const TOOLTIP_SHARED_PRESET_NAME_UNIQUE =
	'Preset name must be unique within your organisation';

export const IS_SHARED_PRESET_LABEL = 'Make available for all team members';
